import styled from 'styled-components';
import { COLOR_GREEN } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  .modal-loading-wrap {
    display: flex;
    justify-content: center;
  }
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
  }

  .bid-wrap {
    padding-top: 16px;
  }
  .checkbox-wrap {
    padding-top: 20px;
  }

  .submit-wrap {
    margin-top: 48px;
    button {
      width: 100%;
    }
  }

  .price-wrap {
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    h2 {
      max-width: 100%;
      color: ${COLOR_GREEN};
      line-height: 90px;
      font-size: 72px;
      font-weight: 900;
    }
  }

  .second-offer {
    margin-top: 16px;

    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-evenly;
    flex-wrap: wrap;

    h2 {
      max-width: 100%;
      line-height: 54px;
      font-size: 48px;
      font-weight: normal;
    }

    &--divider {
      width: 1px;
      background: rgba(47, 46, 65, 0.4);
    }

    &--item {
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .price-wrap {
      padding-top: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;

      h2 {
        font-size: 45px;
        line-height: 50px;
      }
    }

    .second-offer {
      h2 {
        text-align: center;
        font-size: 45px;
        line-height: 50px;
      }

      &--divider {
        display: none;
      }
      &--item {
        width: 100%;
      }
    }
  }
`;
